import styled from "styled-components"

const Form = styled.form`
  padding: ${({ theme }) => theme.spacing.half} 0;
`

export default Form
